import { useState, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useApp } from "../../context/AppContext";
import useAuth from "../../hooks/useAuth";

const menuClass = ({ isActive }) =>
  `sidebar-link ${isActive ? "active" : ""}`;

const getInitials = (value = "") => {
  const words = String(value).trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "AD";
  return words.slice(0, 2).map((word) => word[0]).join("").toUpperCase();
};

const SidebarDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const { siteSettings } = useApp();
  
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  const handleLogout = async () => {
    try {
      await logout();
    } catch {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
    } finally {
      navigate("/login");
    }
  };

  return (
    <>
      <style>
        {`
          /* --- FIX WARNA TEKS MENU & TEMA BUKUOIBOOK --- */
          .dashboard-sidebar {
            background-color: #ffffff;
            border-right: 1px solid #fce7f3; /* Garis batas pink pastel */
          }

          .dashboard-sidebar .sidebar-link {
            color: #4b5563 !important; /* Abu-abu gelap agar sangat jelas terbaca */
            font-weight: 600 !important;
            padding: 12px 15px;
            display: block;
            border-radius: 8px;
            text-decoration: none;
            margin-bottom: 5px;
            transition: all 0.2s ease;
            border-left: 4px solid transparent;
          }
          
          .dashboard-sidebar .sidebar-link:hover {
            background-color: #fffafc !important;
            color: #ec4899 !important; /* Pink BukuOiBook saat disorot */
          }
          
          .dashboard-sidebar .sidebar-link.active {
            background-color: #fdf2f8 !important; /* Latar pink sangat muda */
            color: #8e1628 !important; /* Maroon BukuOiBook saat aktif */
            font-weight: 800 !important;
            border-left: 4px solid #8e1628 !important; /* Aksen garis kiri Maroon */
          }

          .dashboard-sidebar .sidebar-brand-title {
            color: #8e1628 !important; /* Judul Admin CMS Maroon */
            margin: 0;
            font-size: 1.15rem;
            font-weight: 800;
          }

          .dashboard-sidebar .sidebar-brand-subtitle {
            color: #ec4899 !important; /* Subtitle Pink */
            margin: 0;
            font-size: 0.8rem;
            font-weight: 700;
          }

          .btn-logout-sidebar {
            width: 100%;
            padding: 12px;
            background-color: #fff1f2;
            color: #ef4444 !important;
            border: 1px solid #fecaca;
            border-radius: 8px;
            font-weight: 700;
            cursor: pointer;
            transition: 0.2s;
          }

          .btn-logout-sidebar:hover {
            background-color: #fee2e2;
          }

          /* Default Desktop: Sembunyikan tombol toggle mobile */
          .mobile-sidebar-toggle {
            display: none;
            position: fixed;
            top: 15px;
            left: 15px;
            z-index: 1050;
            background: #8e1628; /* Berubah jadi Maroon */
            color: white;
            border: none;
            padding: 10px 15px;
            border-radius: 8px;
            cursor: pointer;
            box-shadow: 0 4px 6px rgba(142, 22, 40, 0.2);
            transition: 0.2s;
          }
          
          .mobile-sidebar-toggle:hover {
            background: #ec4899; /* Pink saat disorot */
          }

          .sidebar-overlay {
            display: none;
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(142, 22, 40, 0.3); /* Overlay agak merah/maroon transparan */
            z-index: 1030;
            backdrop-filter: blur(2px);
          }

          /* ========================================= */
          /* OPTIMASI KHUSUS MOBILE RESPONSIVE         */
          /* ========================================= */
          @media (max-width: 991px) {
            .mobile-sidebar-toggle {
              display: block; 
            }

            .dashboard-sidebar {
              position: fixed;
              top: 0;
              bottom: 0; /* MENGGANTI height: 100vh AGAR LOGOUT TIDAK HILANG */
              left: -100%; 
              width: 260px;
              z-index: 1040;
              background-color: #ffffff;
              box-shadow: 4px 0 15px rgba(0,0,0,0.1);
              transition: left 0.3s ease-in-out;
              display: flex;
              flex-direction: column;
              /* FIX OVERLAP: Dorong konten sidebar ke bawah agar tidak tertutup tombol burger */
              padding-top: 65px !important; 
            }

            .dashboard-sidebar.open {
              left: 0;
            }

            .sidebar-overlay.show {
              display: block;
            }

            .sidebar-nav {
              flex-grow: 1;
              overflow-y: auto; /* MEMASTIKAN MENU BISA DISCROLL */
              padding: 15px;
            }

            .sidebar-footer {
              flex-shrink: 0; /* MEMASTIKAN FOOTER TIDAK MENGECIL ATAU HILANG */
              padding-bottom: max(15px, env(safe-area-inset-bottom));
            }

            .sidebar-brand {
              padding: 0 15px 15px 15px;
              border-bottom: 2px solid #fce7f3;
              display: flex;
              align-items: center;
              gap: 15px;
            }
          }
        `}
      </style>

      <button 
        className="mobile-sidebar-toggle" 
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle Sidebar"
      >
        <span style={{ fontSize: "1.2rem", fontWeight: "bold" }}>{isOpen ? "✕" : "☰"}</span>
      </button>

      <div 
        className={`sidebar-overlay ${isOpen ? "show" : ""}`} 
        onClick={() => setIsOpen(false)} 
      />

      <aside className={`dashboard-sidebar ${isOpen ? "open" : ""}`}>
        <div className="sidebar-brand" style={{ padding: "20px", display: "flex", gap: "15px", alignItems: "center", borderBottom: "2px solid #fce7f3" }}>
          {/* Logo kotak kecil menjadi Maroon */}
          <div className="sidebar-brand-logo" style={{ background: "#8e1628", color: "#fff", padding: "10px", borderRadius: "10px", fontWeight: "900", fontSize: "1.1rem" }}>
            {getInitials(siteSettings?.siteName)}
          </div>
          <div>
            <h2 className="sidebar-brand-title">Admin CMS</h2>
            <p className="sidebar-brand-subtitle">{siteSettings?.siteName || "Solusi IoT Cerdas"}</p>
          </div>
        </div>

        <nav className="sidebar-nav" style={{ padding: "15px", display: "flex", flexDirection: "column", gap: "2px" }}>
          <NavLink to="/dashboard" end className={menuClass}>📊 Dashboard</NavLink>
          <NavLink to="/dashboard/products" className={menuClass}>📦 Produk IoT</NavLink>
          <NavLink to="/dashboard/categories" className={menuClass}>🗂️ Kategori Produk</NavLink>
          <NavLink to="/dashboard/orders" className={menuClass}>🛒 Order / Pesanan</NavLink>
          <NavLink to="/dashboard/blogs" className={menuClass}>📝 Blog & Artikel</NavLink>
          <NavLink to="/dashboard/media" className={menuClass}>🖼️ Media Library</NavLink>
          <NavLink to="/dashboard/users" className={menuClass}>👥 Pengguna</NavLink>
          <NavLink to="/dashboard/settings" className={menuClass}>⚙️ Pengaturan Website</NavLink>
          <NavLink to="/dashboard/messages" className={menuClass}>💬 Pesan Masuk</NavLink>
        </nav>

        <div className="sidebar-footer" style={{ padding: "15px", borderTop: "2px solid #fce7f3", marginTop: "auto" }}>
          <button type="button" className="btn-logout-sidebar" onClick={handleLogout}>
            🚪 Logout Keluar
          </button>
        </div>
      </aside>
    </>
  );
};

export default SidebarDashboard;